



































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { PropType } from 'vue';
import DraggableTreeviewNode from '@/components/orderdocs/DraggableTreeviewNode.vue';
import DocumentMixin from '@/mixins/DocumentMixin';
import { OrderRec } from '@/interfaces';

@Component({
  components: {
    DraggableTreeviewNode
  }
})
export default class DraggableTreeview extends Mixins(DocumentMixin) {
  @Prop() public readonly rec!: OrderRec;
  @Prop({
    type: Array as PropType<Array<{ id: string }>>,
    default: (): Array<{ id: string }> => {
      return [];
    }
  })
  public value!: Array<{ id: string }>;
  @Prop({ type: String, default: null }) public group;
  @Prop({ type: String }) public expandIcon;
  @Prop({ type: Boolean }) public isReadOnly;
  @Prop({ type: Array }) public active;
  @Prop({ type: Number }) public version;

  public localValue: Array<{ id: string }> = [...this.value];

  public updateValue(value) {
    this.localValue = value;
    this.$emit('input', this.localValue);
  }
  public updateItem(itemValue) {
    const index = this.localValue.findIndex(v => v.id === itemValue.id);
    this.$set(this.localValue, index, itemValue);
    this.$emit('input', this.localValue);
  }

  public addItem(value) {
    this.$emit('addItem', this.parseId(value.id), value.children.length);
  }

  @Watch('value') public valueChangedChanged(
    value: Array<{ id: string }>,
    oldValue: Array<{ id: string }>
  ) {
    this.localValue = [...value];
  }
}
